import Style from './style'

import addonIcon from 'shared/assets/add-on.svg'
import calendarIcon from 'shared/assets/calendar.svg'
import groupIcon from 'shared/assets/group.svg'
import retryIcon from 'shared/assets/retry.svg'
import ticketIcon from 'shared/assets/ticket.svg'
import walletIcon from 'shared/assets/wallet.svg'
import timestampCalculator from 'shared/lib/timestampCalculator'
import {getTicketInfo} from 'shared/utils/eventUtils'
import ActionButton from '../ScanResultBottomSheet/ui/ActionButton'
import BadgeSection from './ui/BadgeSection'
import RefreshButton from '../ScanResultBottomSheet/ui/RefreshButton'

const StoreInfo = ({
	data,
	className,
	refetch,
	user_idx,
	isLoading,
	...props
}) => {
	const {max_reentry, count} = data?.participation_history || {}
	const {
		can_eliminate,
		can_addon,
		can_reenter,
		event_state,
		required_tickets,
		has_joined,
		user_can_join,
		max_entry,
	} = data || {}
	const {rest_player, add_on_chip} = data?.event_timer || {}
	const {total_available} = data?.available_tickets || {}
	const {isEnoughVouchers, isEnoughReEntry} = getTicketInfo(data)

	const reEntryCount = count && count > 0 ? count - 1 : 0

	const rowData = [
		{
			icon: calendarIcon,
			value: timestampCalculator(data?.event_date) || '-',
		},
		{
			icon: groupIcon,
			value: `${rest_player || 0}/${max_entry || '-'} 명`,
			highlight: max_entry && rest_player >= max_entry,
		},
		{
			icon: ticketIcon,
			title: '입장 필요',
			value: `${required_tickets || 0} 장`,
			hidden: can_eliminate,
		},
		{
			icon: retryIcon,
			title: '재입장 사용',
			value: `${reEntryCount}/${max_reentry || '-'} 회`,
			hidden: !has_joined,
			highlight: !isEnoughReEntry,
		},

		{
			icon: addonIcon,
			title: '추가 사용',
			value: `${can_addon ? '0' : `${add_on_chip || ''}`}/${
				add_on_chip || '-'
			} 회`,
			hidden: !has_joined,
		},
		{
			icon: ticketIcon,
			title: '재입장 필요',
			value: `${required_tickets || 0} 장`,
			hidden: !can_reenter,
		},
		{
			icon: walletIcon,
			title: '보유',
			value: `${total_available || 0} 장`,
			hidden: can_eliminate,
			highlight: !isEnoughVouchers,
		},
	]

	return (
		<Style.Container
			can_eliminate={can_eliminate}
			className={className}
			{...props}
		>
			<Style.ContentContainer>
				<Style.NameRow>
					<Style.TournamentName>{data?.event_name || '-'}</Style.TournamentName>
					<BadgeSection
						event_state={event_state}
						can_eliminate={can_eliminate}
						user_can_join={user_can_join}
					/>
					<RefreshButton onClick={refetch} loading={isLoading} />
				</Style.NameRow>

				<Style.InfoContainer>
					{rowData.map((elem) => (
						<Style.InfoRow hidden={elem?.hidden}>
							<Style.IconContainer>
								<img src={elem?.icon} alt={elem?.label} />
							</Style.IconContainer>
							<Style.InfoText highlight={elem?.highlight}>
								{elem?.title} :
							</Style.InfoText>
							<Style.InfoText highlight={elem?.highlight}>
								{elem?.value}
							</Style.InfoText>
						</Style.InfoRow>
					))}
				</Style.InfoContainer>
			</Style.ContentContainer>
			<ActionButton
				data={data}
				can_reenter={can_reenter}
				can_eliminate={can_eliminate}
				can_addon={can_addon}
				count={count}
				max_reentry={max_reentry}
				user_idx={user_idx}
				required_tickets={required_tickets}
				refetch={refetch}
			/>
		</Style.Container>
	)
}

export default StoreInfo
